import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var deleteQuestionRes;
export const deleteQuestionTodo = createAsyncThunk('deleteQuestion', async (data) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))

    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'quiz/delete_questions',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "question_id": data,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return deleteQuestionRes = res.data
    } catch (error) {
        return deleteQuestionRes = error.response.data
    }
})